import { useStore } from '@stores';
import { useTenantVat } from '@hooks';
import { useEffect } from 'react';

export const useOrder = (id: string | undefined) => {
  const { orderStore, serviceStore, vehicleStore } = useStore();
  const { order, loading } = orderStore;
  const vat = useTenantVat();

  useEffect(() => {
    id && orderStore.get({ id });

    return () => {
      orderStore.resetOrder();
      serviceStore.clearOrderServices();
      vehicleStore.clearVehicle();
    };
  }, [orderStore, serviceStore, vehicleStore, id]);

  // Init services from order once loaded.
  //
  // orderStore.order is shared, so a request fired by the panel that has just closed can land after
  // this one mounted and briefly put the wrong job there. Seeding only from the job we asked for
  // keeps the basket matched to the panel the user is looking at.
  useEffect(() => {
    if (order && order.id === id) {
      serviceStore.initFromOrder(order, vat);
    }
  }, [order, vat, serviceStore, id]);

  // Only the job that was asked for. The slot is shared, so for the moment after a panel opens it
  // can still hold the job of the one that just closed - handing that out showed one job's
  // details (and saved them) under another job's row.
  return { order: !id || order?.id === id ? order : undefined, loading };
};
